import { useEffect, useState } from 'react';
import { X, Info } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Row = ({ label, ok }) => (
  <div className="flex items-center justify-between py-1.5">
    <span className="font-jetbrains text-xs text-white/70">{label}</span>
    <span className={`font-jetbrains text-[10px] uppercase tracking-widest ${ok ? 'text-emerald-400' : 'text-white/40'}`}>
      {ok ? 'Configurado' : 'Pendiente'}
    </span>
  </div>
);

const SocialCredentialsInfo = ({ onClose }) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    fetch(`${API}/social/status`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(setStatus)
      .catch(() => {});
  }, []);

  return (
    <div className="mb-4 p-4 bg-[#0F0F0F] border border-neon-red/25" data-testid="social-credentials-info">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-start gap-2">
          <Info className="w-4 h-4 text-neon-red mt-0.5" />
          <div>
            <h4 className="font-outfit text-sm font-bold text-white">Credenciales de Redes</h4>
            <p className="font-jetbrains text-[11px] text-white/50 mt-1">
              Estado de las APIs oficiales. Nada se publica sin tu confirmación explícita.
            </p>
          </div>
        </div>
        <button onClick={onClose} className="text-white/50 hover:text-white">
          <X className="w-4 h-4" />
        </button>
      </div>

      {!status ? (
        <p className="font-jetbrains text-xs text-white/50">Cargando...</p>
      ) : (
        <div className="space-y-3 text-sm">
          <div>
            <p className="font-outfit text-xs font-semibold text-white/80 mb-1">TikTok</p>
            <Row label="Credenciales globales (app)" ok={status.tiktok?.global_configured} />
            <Row label="Mazal Kids · token de cuenta" ok={status.tiktok?.mazal_kids} />
            <Row label="El Último Testigo · token de cuenta" ok={status.tiktok?.ultimo_testigo} />
          </div>
          <div>
            <p className="font-outfit text-xs font-semibold text-white/80 mb-1">Instagram</p>
            <Row label="Mazal Kids · token + account_id" ok={status.instagram?.mazal_kids} />
            <Row label="El Último Testigo · token + account_id" ok={status.instagram?.ultimo_testigo} />
          </div>
          <div>
            <p className="font-outfit text-xs font-semibold text-white/80 mb-1">YouTube</p>
            <Row label="Mazal Kids · OAuth + refresh token" ok={status.youtube?.mazal_kids} />
            <Row label="El Último Testigo · OAuth + refresh token" ok={status.youtube?.ultimo_testigo} />
          </div>
        </div>
      )}

      <p className="mt-4 font-jetbrains text-[10px] text-white/40 leading-relaxed">
        Cuando quieras habilitar lectura de métricas o publicación oficial en una plataforma,
        avísame y te doy la lista exacta de credenciales a proporcionar. Sin credenciales,
        Alivan prepara los borradores y quedan listos para publicación manual.
      </p>
    </div>
  );
};

export default SocialCredentialsInfo;
